export const TourOperators = {
  alpiIDs :  [1108, 4041, 4097, 4130, 5013, 5035, 5052, 5089, 5090],
  otaId:  165
}
